import { Component, OnInit, Input } from '@angular/core';
import { InfrastructureService } from 'src/app/@core/services/infrastructure/infrastructure.service';
import { Router } from '@angular/router';
import { Infrastructure } from 'src/app/@core/models/infrastructure/Infrastructure.model';
import { MatSnackBar } from '@angular/material/snack-bar';
import { TranslateService } from '@ngx-translate/core';
import { AppService } from 'src/app/@core/services/app/app.service';
import { DarkModeService } from 'src/app/@core/services/dark-mode/dark-mode.service';

@Component({
  selector: 'app-global-user-admin-confirm-step',
  templateUrl: './global-user-admin-confirm-step.component.html',
  styleUrls: ['./global-user-admin-confirm-step.component.scss'],
})
export class GlobalUserAdminConfirmStepComponent implements OnInit {
  constructor(
    private infraService: InfrastructureService,
    private readonly router: Router,
    private snackBar: MatSnackBar,
    private translate: TranslateService,
    private appService: AppService,
    public darkModeService: DarkModeService
  ) { }

  @Input() infrastructure: Infrastructure;

  ngOnInit() {
   }

   confirmGlobalAdmins() {
    const loading = this.appService.openLoading();
    let ok: () => void;

    ok = () => {
      this.infraService.updateGlobalAdminsInfra(this.infrastructure).subscribe((updatedGlobalAdmins) => {
        updatedGlobalAdmins ? this.closeOperation('GLOBAL_USERS_ADMIN.GLOBAL_USER_ADMINS_UPDATED', loading) : loading.close();
        });
    };

    this.translate.get(['ALERT.CONFIRM-TITLE', 'ALERT.CONFIRM-MESSAGE-GLOBAL-ADMINS']).subscribe(values => {
      this.appService.openDialog(values['ALERT.CONFIRM-TITLE'], values['ALERT.CONFIRM-MESSAGE-GLOBAL-ADMINS'], ok, () => { loading.close(); });
    });
  }

  private closeOperation(title: string, loading) {
    const msg = this.translate.instant(title);
    this.snackBar.open(msg, null, { duration: 5000 });
    this.router.navigateByUrl('/RefreshComponent', { skipLocationChange: true }).then(() => {
      this.router.navigate(['/v1/status']);
    }); 
    loading.close(); 
  }
}

